document.addEventListener("DOMContentLoaded", function() {
	const $ = jQuery.noConflict();

	$('.section_acf-flexible-items > .accordion .accordion-button').addClass('collapsed');

	// ACF Accordion multi items unique IDs for each item if more then 1 per page
	var accordion = $('.section_acf-flexible-items > .accordion').length;
	if ( accordion > 1 ) {

		$('.section_acf-flexible-items >.accordion').each(function(a) {
			a++;
			var id = $(this).attr('id');
			$(this).attr('id',id + '-' + a);

			$(this).find('.accordion-item').each(function(item) {
				item++;
				var target = $(this).find('.accordion-button').attr('data-bs-target');
				$(this).find('.accordion-button').attr('data-bs-target',target + '-' + item + a);
				var controls = $(this).find('.accordion-button').attr('aria-controls');
				$(this).find('.accordion-button').attr('aria-controls',controls + '-' + item  + a);
				var item_id = $(this).find('.collapse').attr('id');
				$(this).find('.collapse').attr('id',item_id + '-' + item  + a);
				var item_parent = $(this).find('.collapse').attr('data-bs-parent');
				$(this).find('.collapse').attr('data-bs-parent',item_parent + '-' + item  + a);
			});
		});
	}

	$('.section_acf-flexible-items > .accordion .accordion-button').click( function(e) {
		$('.collapse').collapse('hide');
	});
});